import classNames from 'classnames';
import styles from './LinkBox.module.scss';
import { Heading, Icon, Link, LinkButton } from 'ui/components';
import ChevronRight from 'ui/icons/DEF_Chevron-right.svg';
import ChevronLeft from 'ui/icons/icon-global-chevron-up.svg';
import Anchor from 'ui/icons/DEF_Anchor.svg';

interface MoreElementsLinkProps {
	link: Umbraco.Link;
	className: string;
}

const MoreElementsLink: React.FC<MoreElementsLinkProps> = ({ link, className }) => (
	<div className={className}>
		<Link style="secondary" url={link?.url} title={link?.name} target={link?.target} children={link?.name} />
		<Icon size="sm">
			<ChevronRight />
		</Icon>
	</div>
);

export interface LinkBoxProps {
	heading?: string;
	links: Umbraco.Link[];
	moreElementsLink?: Umbraco.Link;
	variant: 'inline' | 'boxed' | 'list';
	backButton?: Umbraco.Link;
}

export const LinkBox: React.FC<LinkBoxProps> = ({ heading, links, moreElementsLink, variant, backButton }) => (
	<div className={classNames(styles.LinkBox, styles[`LinkBox_${variant}`])}>
		{heading && (
			<div className={classNames(styles.LinkBox_headerRow)}>
				<Heading
					headingLevel="h3"
					style={variant === 'inline' || variant === 'list' ? 'sm' : 'md'}
					className={classNames(styles.LinkBox_heading)}
				>
					{heading}
				</Heading>
				{moreElementsLink && (
					<MoreElementsLink
						link={moreElementsLink}
						className={classNames(styles.LinkBox_moreElementsLinkDesktop, styles.LinkBox_moreElementsLink)}
					/>
				)}
			</div>
		)}
		<div className={classNames(styles.LinkBox_links, { [styles.LinkBox_linksList]: variant === 'list' })}>
			{variant === 'list'
				? links.map((link, index) => (
						<Link
							key={index}
							style="secondary"
							url={link?.url}
							title={link?.name}
							target={link?.target}
							className={styles.LinkBox_listLink}
						>
							<Icon size="sm">
								<Anchor />
							</Icon>
							{link?.name}
						</Link>
				  ))
				: links.map((link, index) => (
						<LinkButton
							key={index}
							url={link?.url}
							title={link?.name}
							target={link?.target}
							icon="chevronRight"
							style={variant === 'inline' ? 'linkBoxPrimary' : 'linkBoxSecondary'}
							children={link?.name}
						/>
				  ))}
			{backButton && (
				<LinkButton
					url={backButton.url}
					title={backButton.name}
					target={backButton.target}
					icon="chevronRight"
					style={variant === 'inline' ? 'linkBoxPrimary' : 'linkBoxSecondary'}
					children={backButton.name}
				></LinkButton>
			)}
		</div>

		{moreElementsLink && (
			<MoreElementsLink
				link={moreElementsLink}
				className={classNames(styles.LinkBox_moreElementsLinkMobile, styles.LinkBox_moreElementsLink)}
			/>
		)}
	</div>
);
